export const PERIOD_TYPE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
}

export const PERIOD_TYPE_DATA = [
  {
    label: 'score.main.YEARLY',
    value: 'Yearly',
    isI18n: true,
  },
  {
    label: 'score.main.QUARTERLY',
    value: 'Quarterly',
    isI18n: true,
  },
  {
    label: 'score.main.MONTHLY',
    value: 'Monthly',
    isI18n: true,
  },
]
